"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.caretMixin = exports.Select = void 0;
var _themeGet = require("@styled-system/theme-get");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Box = require("../Box");
var _Flex = require("../Flex");
var _Text = require("../Text");
var _tokens = require("./tokens");
var _excluded = ["description", "disabled", "error", "focus", "hover", "id", "name", "options", "required", "selected", "title", "variant", "onSelect"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/** A drop-down select menu */
var Select = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var description = _ref.description,
    disabled = _ref.disabled,
    error = _ref.error,
    focus = _ref.focus,
    hover = _ref.hover,
    id = _ref.id,
    name = _ref.name,
    options = _ref.options,
    required = _ref.required,
    selected = _ref.selected,
    title = _ref.title,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "default" : _ref$variant,
    onSelect = _ref.onSelect,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _splitBoxProps = (0, _Box.splitBoxProps)(rest),
    _splitBoxProps2 = _slicedToArray(_splitBoxProps, 2),
    boxProps = _splitBoxProps2[0],
    selectProps = _splitBoxProps2[1];
  return /*#__PURE__*/_react.default.createElement(_Box.Box, _extends({
    width: "100%"
  }, boxProps), /*#__PURE__*/_react.default.createElement(_Flex.Flex, _extends({
    as: "label"
  }, variant === "inline" ? {
    flexDirection: "row",
    alignItems: "center"
  } : {
    flexDirection: "column",
    alignItems: "flex-start"
  }, id ? {
    for: id
  } : {}), /*#__PURE__*/_react.default.createElement("div", null, title && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "xs",
    lineHeight: variant === "inline" && description === undefined ? 1 : undefined
  }, title, required && /*#__PURE__*/_react.default.createElement(_Box.Box, {
    as: "span",
    color: "brand"
  }, "*")), description && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "xs",
    color: "black60"
  }, description)), /*#__PURE__*/_react.default.createElement(Container, {
    variant: variant,
    disabled: !!disabled,
    hover: !!hover,
    error: error,
    focus: !!focus,
    mt: variant !== "inline" && (title || description) ? 0.5 : 0
  }, /*#__PURE__*/_react.default.createElement("select", _extends({
    ref: ref,
    id: id,
    disabled: disabled,
    name: name,
    value: selected,
    onChange: function onChange(event) {
      onSelect && onSelect(event.target.value);
    }
  }, selectProps), options.map(function (_ref2) {
    var value = _ref2.value,
      text = _ref2.text;
    return /*#__PURE__*/_react.default.createElement("option", {
      value: value,
      key: value
    }, text);
  })))), error && typeof error === "string" && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "xs",
    mt: 0.5,
    color: "red100"
  }, error));
});
exports.Select = Select;
Select.displayName = "Select";
var resetMixin = (0, _styledComponents.css)(["appearance:none;background:none;border:none;outline:0;text-indent:0.01px;text-overflow:\"\";border-radius:0;&:-moz-focusring{color:transparent;text-shadow:0 0 0 black;}option:not(:checked){color:black;}"]);

/** Creates a small caret */
var caretMixin = (0, _styledComponents.css)(["&::after{content:\"\";cursor:inherit;width:0;height:0;position:absolute;top:50%;transform:translateY(-50%);right:", ";pointer-events:none;border-left:4px solid transparent;border-right:4px solid transparent;border-top:4px solid ", ";}"], (0, _themeGet.themeGet)("space.1"), function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? (0, _themeGet.themeGet)("colors.black10") : (0, _themeGet.themeGet)("colors.black100");
});
exports.caretMixin = caretMixin;
var Container = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Select__Container",
  componentId: "sc-1weszjl-0"
})(["position:relative;width:100%;> select{", ";width:100%;padding:0 24px 0 ", ";font-family:", ";border:0;border-bottom:1px solid;cursor:pointer;line-height:1;transition:color 0.25s,background-color 0.25s,border-color 0.25s;", ";}", ""], resetMixin, (0, _themeGet.themeGet)("space.1"), (0, _themeGet.themeGet)("fonts.sans"), function (props) {
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", " &:hover{", "}&:focus{", "}&:disabled{cursor:default;", "}"], _tokens.SELECT_STATES.default, props.hover && _tokens.SELECT_STATES.hover, props.focus && _tokens.SELECT_STATES.focus, props.disabled && _tokens.SELECT_STATES.disabled, props.error && _tokens.SELECT_STATES.error, _tokens.SELECT_STATES.hover, _tokens.SELECT_STATES.focus, _tokens.SELECT_STATES.disabled);
}, caretMixin);
//# sourceMappingURL=Select.js.map